import React, { useState } from 'react';
import { AddAppointment, Container1, Container2, BoxContainer, BoxInner1, InnerAppointments, Text, Texts, DataContainer, StatusData, LineContainer, MenuContainer, TreatmentStatus, InnerBox, PagingContainer } from './Styles';
import { ReactComponent as Add } from '../../../../../../src/assets/images/add-square.svg';
import InputSelect from 'src/components/shared/Form/Select';
import { ReactComponent as MenuIcon } from '../../../../../assets/images/more.svg';
import Paging from 'src/components/App/Paging';
import dayjs from 'dayjs';
import { Box } from '@mui/material';
import NoDataFound from '../../NoDataFound/NoDataFound';
import TreatmentTabForm from '../Forms/TreatmentTabForm';
import DialogBox from 'src/components/shared/Dialog/DialogBox';

const TreatmentCard = ({ treatment = [], page, perPage, setPage, totalCount, fetchTreatments }) => {
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const dayMap = {
        M: 'Mon',
        T: 'Tue',
        W: 'Wed',
        Th: 'Thu',
        F: 'Fri',
        S: 'Sat',
        Su: 'Sun'
    };
    const data = treatment.map((treatmentData) => ({
        treatmentId: treatmentData.id,
        treatmentName: treatmentData.name,
        type: treatmentData.treatmentType,
        schduleDays: treatmentData.treatmentType === 'visiting'
            ? treatmentData.days?.map(day => dayMap[day.toLowerCase()] || day).join(', ')
            : '-',
        dateOrTime: treatmentData.treatmentType === 'visiting'
            ? (treatmentData.time ? dayjs(treatmentData.time).format('h:mm A') : '-')
            : treatmentData.dateTimes && treatmentData.dateTimes.length > 0
                ? `${dayjs(treatmentData.dateTimes[0].date).format('D MMM, YYYY')} , ${dayjs(treatmentData.dateTimes[0].time).format('h:mm A')}`
                : '-',
        status: `${treatmentData.remaining}/${treatmentData.total} Complete `,
    }))
    return (
        <>
            <Container1>
                <AddAppointment
                    startIcon={<Add width="18px" height="18px" />}
                    onClick={handleOpen}
                >Add Treatment</AddAppointment>

            </Container1>
            <Container2>
                <InnerAppointments>
                    <InnerBox isEmpty={data.length === 0}>
                        {data.length === 0 ? (
                            <NoDataFound
                                title="No Treatment Found!"
                                buttonText="Add Treatment"
                                buttonIcon={Add}
                                onClick={handleOpen}
                            />
                        ) : (
                            <>
                                {
                                    data.map((item) => (
                                        <BoxContainer key={item.treatmentId}>
                                            <BoxInner1>
                                                <DataContainer>
                                                    <Text>{item.treatmentName}</Text>
                                                    <Texts>{item.type}</Texts>
                                                </DataContainer>
                                                <TreatmentStatus label={item.status} />
                                            </BoxInner1>
                                            <LineContainer />
                                            <BoxInner1>
                                                <DataContainer>
                                                    <Text>{item.schduleDays}</Text>
                                                    <Texts>{item.dateOrTime}</Texts>
                                                </DataContainer>
                                                <MenuContainer>
                                                    <MenuIcon />
                                                </MenuContainer>
                                            </BoxInner1>
                                        </BoxContainer>
                                    ))
                                }
                            </>
                        )}
                    </InnerBox>
                    <PagingContainer>
                        <Paging
                            page={page}
                            perPage={perPage}
                            count={totalCount || 0}
                            onChange={(newPage) => setPage(newPage)}
                        />
                    </PagingContainer>
                </InnerAppointments>
                <DialogBox open={open} onClose={handleClose} >
                    <TreatmentTabForm onClose={handleClose} fetchReports={fetchTreatments} />
                </DialogBox>
            </Container2>
        </>
    )
}

export default TreatmentCard
